import { render, staticRenderFns } from "./name.vue?vue&type=template&id=7d7d44dc&scoped=true&"
import script from "./name.vue?vue&type=script&lang=js&"
export * from "./name.vue?vue&type=script&lang=js&"
import style0 from "./name.vue?vue&type=style&index=0&id=7d7d44dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7d44dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d7d44dc')) {
      api.createRecord('7d7d44dc', component.options)
    } else {
      api.reload('7d7d44dc', component.options)
    }
    module.hot.accept("./name.vue?vue&type=template&id=7d7d44dc&scoped=true&", function () {
      api.rerender('7d7d44dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/point/PointQuotaLimit/validation/name.vue"
export default component.exports